module.exports = __webpack_public_path__ + "static/media/thermocycler-closed.de393c5b.svg";